module.exports = __webpack_public_path__ + "img/7.f8c4178c.jpg";